// Run worker over items with at most `concurrency` running at once.
// Never rejects: each result is { ok, value } or { ok: false, error }.
export default async (items, worker, concurrency = 3) => {
	const results = new Array(items.length);
	let next = 0;

	const run = async () => {
		while (next < items.length) {
			const index = next++;

			try {
				results[index] = { ok: true, value: await worker(items[index], index) };
			} catch (error) {
				results[index] = { ok: false, error };
			}
		}
	};

	const workers = Array.from(
		{ length: Math.max(1, Math.min(concurrency, items.length)) },
		run
	);

	await Promise.all(workers);

	return results;
};
